import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  TextField,
} from '@material-ui/core';
import { useStyles } from '../styles';


const QuoteMarketingSegmentsFilter = ({ marketingSegments, setMarketingSegments }) => {
  const classes = useStyles();
  const options = marketingSegments.map((segment) => segment.label);

  const handleFilterChange = (_, value) => {
    if (!value) {
      setMarketingSegments(marketingSegments);
    } else {
      const filteredSegments = marketingSegments.filter((segment) =>
        segment.label === value
      );
      setMarketingSegments(filteredSegments);
    }
  };

  return (
    <Autocomplete
      options={options}
      onChange={handleFilterChange}
      renderInput={(params) => <TextField {...params} variant="outlined" label="Type or search Marketing Segment" />}
      fullWidth
      size="small"
      classes={{
        inputRoot: classes.autocompleteInput,
      }}
    />
  );
};

export default QuoteMarketingSegmentsFilter;
